<template>
    <section class="tw-container tw-mx-auto">
        <slot/>
        <v-bottom-navigation :value="pathname" color="#fff" class="tw-rounded tw-text-white" fixed v-if="loaded && !tenant">
                <v-btn value="/backstage" @click="visit(`/artist/${artist.artista_url}/backstage`)">
                    <span>Feed</span>
                    <v-icon>fas fa-home</v-icon>
                </v-btn>
                <v-btn value="/photos" @click="visit(`/artist/${artist.artista_url}/backstage/photos`)">
                    <span>Imagens</span>
                    <v-icon>far fa-image</v-icon>
                </v-btn>
                <v-btn value="/videos" @click="visit(`/artist/${artist.artista_url}/backstage/videos`)">
                    <span>Vídeos</span>
                    <v-icon>fas fa-video</v-icon>
                </v-btn>
                <!-- <v-btn>
                    <span>Produtos</span>
                    <v-icon>fas fa-star</v-icon>
                </v-btn> -->
        </v-bottom-navigation>
        <v-bottom-navigation :value="pathname" color="#fff" class="tw-rounded tw-text-white" fixed v-if="loaded && tenant">
                <v-btn value="/backstage" @click="visit(`/backstage`)">
                    <span>Feed</span>
                    <v-icon>fas fa-home</v-icon>
                </v-btn>
                <v-btn value="/photos" @click="visit(`/backstage/photos`)">
                    <span>Imagens</span>
                    <v-icon>far fa-image</v-icon>
                </v-btn>
                <v-btn value="/videos" @click="visit(`/backstage/videos`)">
                    <span>Vídeos</span>
                    <v-icon>fas fa-video</v-icon>
                </v-btn>
                <!-- <v-btn>
                    <span>Produtos</span>
                    <v-icon>fas fa-star</v-icon>
                </v-btn> -->
        </v-bottom-navigation>
    </section>
</template>

<script>
import Layout from '@/Shared/SingleLayout';
import EventBus from '@/eventbus';
export default {
    data(){
        return{
            pathname: '/backstage',
            artist: '',
            spotifyArtist: '',
            loaded: false,
            pageOptions: '',
        }
    },
    methods: {
        visit(url){
            this.$inertia.get(url);
        }
    },
    created(){
        const vm = this;
        EventBus.$on('artist', (data) => {
            vm.artist = data.artist;
            vm.spotifyArtist = data.spotifyArtist;
            vm.pageOptions = data.pageOptions;
            vm.loaded = true
        });
    },
    mounted(){
        if(window.location.pathname.includes('/backstage')){
            this.pathname = '/backstage'
        }
        if(window.location.pathname.includes('/photos')){
            this.pathname = '/photos'
        }
        if(window.location.pathname.includes('/videos')){
            this.pathname = '/videos'
        }

        this.$inertia.on('start', (event) => {
            var pathname = event.detail.visit.url
            if(pathname.includes('/backstage')){
                this.pathname = '/backstage'
            }
            if(pathname.includes('/photos')){
                this.pathname = '/photos'
            }
            if(pathname.includes('/videos')){
                this.pathname = '/videos'
            }
        });
    },
}
</script>

<style>
.theme--dark.v-bottom-navigation .v-btn:not(.v-btn--active){
    color: #ffffff5c !important;
}
</style>
